import e from"../GA/utils/dataLayerPush.js";const t=e((()=>({event:"clickEvent",eventAction:"click",eventCategory:"produto:compra-internacional",eventLabel:"entendi"})));export{t as importTaxesInfoModalClose};
